import { render, staticRenderFns } from "./PopupFoodDiaryViewSkeleton.vue?vue&type=template&id=677f242c&scoped=true"
import script from "./PopupFoodDiaryViewSkeleton.vue?vue&type=script&lang=js"
export * from "./PopupFoodDiaryViewSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f242c",
  null
  
)

export default component.exports